<template>
  <bottom-bar-layout class="page-plan-detail"
                     :show-bar="render.bottomBar.show"
                     :bar-height="render.benefitBar && render.benefitBar.show ? 180 : 120"
                     :target-id="plan.id"
                     :target-type="type"
                     :show-consult="render.showConsult"
                     :is-show-guide-popup="false"
  >
    <!-- 头部 -->
    <plan-header :plan="plan"
                 :price="render.primaryPrice"
                 @disabledJoin="handleDisabledJoin"
    />

    <product-content v-model="tabSelected"
                     :nav-bar-list="navBarList"
                     :product-type="plan.type"
                     :product="plan"
                     :reviews="reviews"
    />

    <!-- bottom bar -->
    <template #tabbar>
      <bottom-bar :benefit-bar="render.benefitBar"
                  :sell="plan.sell"
                  :product="product"
                  :render-price="render.bottomBar.renderPrice"
                  :action-bar="render.bottomBar.actionBar"
                  @disabledJoin="handleDisabledJoin"
      />
    </template>

    <joined-member-bar :list="render.joinedMemberList"
    />

  </bottom-bar-layout>
</template>

<script>
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import PlanHeader from '@/pages/Plan/components/PlanDetailHeader';
  import ProductContent from '@/components/ProductDetail/Content';
  import BottomBar from '@/components/ProductDetailBottom/Bar';
  import { getPlanDetail } from '@/services/plan';
  import JoinedMemberBar from '@/pages/Plan/components/JoinedMemberBar';
  import event from '@/utils/bus';

  export default {
    name: 'PlanDetail',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    components: {
      BottomBarLayout,
      PlanHeader,
      ProductContent,
      BottomBar,
      JoinedMemberBar,
    },
    data() {
      return {
        type: 'learn',
        plan: {
          id: 0,
          cover: '',
          title: '',
          summary: '',
          about: '',
          products: [],
          sell: {
            startTime: '',
            status: '',
          },
          type: 'audioLearn',
        },
        tabSelected: 'intro',

        reviews: {
          start: 0,
          count: 0,
          list: [],
        },

        render: {
          primaryPrice: {
            current: {
              value: 0,
              name: '',
            },
            origin: {
              value: 0,
              name: '',
            },
            benefit: null,
          },
          benefitBar: {
            show: false,
            desc: '',
            startTime: 0,
            endTime: 0,
          },
          bottomBar: {
            show: false,
            actionBar: {
              type: 'default',
              buttons: [],
            },
            renderPrice: {
              value: 0,
              delete: 0,
              name: '',
            },
          },
          showConsult: false,
          navBar: [
            {
              name: '计划简介',
              type: 'intro',
              show: true,
            },
            {
              name: '评价',
              type: 'review',
              show: true,
            },
          ],
          joinedMemberList: [],
        },
      };
    },
    computed: {
      id() {
        return parseInt(this.$route.params.id, 10);
      },
      product() {
        return { type: 'plan', id: this.plan.id };
      },
      navBarList() {
        return this.render.navBar.filter(item => item.show);
      },
    },
    methods: {
      async getPlanDetail(id) {
        const data = await getPlanDetail(id);

        this.plan = data.plan;

        this.reviews = data.reviews;

        this.render = data.render;
      },
      handleDisabledJoin() {
        this.getPlanDetail(this.id);
      },
    },
    created() {
      const { id } = this.$route.params;
      this.getPlanDetail(id);
      event.$once('updateDetail', () => {
        this.getPlanDetail(id);
      });
    },
    beforeRouteUpdate(to, from, next) {
      const { id } = to.params;
      this.getPlanDetail(id);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .plan-intro {
    /deep/ p {
      margin: 0;
    }
    /deep/ img, /deep/ iframe {
      display: block;
      max-width: 100%;
    }
    /deep/ video {
      display: block;
      margin: 0 auto;
      width: 690px;
      height: 388px;
    }
  }

  .group-buy-block {
    margin-bottom: @size-small;
  }
</style>
